import { render, staticRenderFns } from "./HelpGoogleReview.vue?vue&type=template&id=9c180b46"
import script from "./HelpGoogleReview.vue?vue&type=script&lang=js"
export * from "./HelpGoogleReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports